/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Album } from './album';
import { Artist } from './artist';
import { Tag } from './tag';
import { Tempo } from './tempo';

export interface Media {
    album?: Album;
    artist?: Artist | string;
    artistName?: string;
    /**
     * Duration in sec
     */
    duration?: number;
    /**
     * Media file checksum
     */
    fileChecksum?: string;
    formatedDuration?: string;
    fullTitle?: string;
    id?: string;
    /**
     * This date is set server side to make the object available or not for the next Sync
     */
    localUpdateDate?: Date;
    /**
     * this date is set server side when the object is updated from the app
     */
    remoteUpdateDate?: Date;
    /**
     * File size in octet
     */
    size?: number;
    /**
     * Tags
     */
    tags?: Array<Tag>;
    /**
     * Tempos
     */
    tempos?: Array<Tempo>;
    /**
     * Title
     */
    title?: string;
    type?: Media.TypeEnum;
    provider?: string;
}
export namespace Media {
    export type TypeEnum = 'AUDIO' | 'VIDEO';
    export const TypeEnum = {
        AUDIO: 'AUDIO' as TypeEnum,
        VIDEO: 'VIDEO' as TypeEnum
    };
}
